<template>
  <div class="real-area">
    <div class="real-area-left">
      <div 
        class="warehouse-row"
        :class="{'is-active': activeIndex === index}"
        v-for="(item, index) in warehouseRealAreaList"
        :key="index"
        @click="selectWarehouse(item, index)"
      >
        <div class="warehouse-row-title">
          <img class="warehouse-img" src="../../../../assets/images/warehouse/warehouse-orange.png">
          <span class="warehouse-name" :title="item.name">{{ item.name }}</span>
        </div>
        <div class="nums-info">
          <div class="goods-shelves">
            <p class="goods-shelves-nums">{{ item.warehouseArea }}</p>
            <p class="goods-shelves-title">仓库面积（㎡）</p>
          </div>
          <div class="goods-shelves">
            <p class="goods-shelves-nums">{{ item.realArea }}</p>
            <p class="goods-shelves-title">实占面积（㎡）</p>
          </div>
        </div>
      </div>
    </div>
    <div class="real-area-right">
      <div class="real-area-right-top right-top-active">
        <div class="real-area-right-top-search">
          <span class="real-area-right-top-search-title">导入日期：</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            :clearable="false"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <span class="real-area-right-top-search-title project-title">项目名称：</span>
          <el-select
            v-model="projectId"
            filterable
            clearable
            placeholder="请选择项目名称"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button
            class="btn-blue search-btn"
            icon="el-icon-search"
            @click="searchRealArea"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" class="btn-gray" @click="reset"
            >重置</el-button
          >
        </div>
      </div>
      
      <div class="title-container">
        <p class="table-title">实占面积列表</p>
        <div class="btn-container">
          <div class="upload-real" @click="downLoadExcel">
            <span class="upload-real-img"></span>
            <span>导出</span>
          </div>
          <div class="bill-recalculation" @click="openRentRecalculation">
            <span class="bill-recalculation-img"></span>
            <span>场租重算</span>
          </div>
          <div class="upload-warehouse" @click="openUploadExcel">
            <span class="upload-warehouse-img"></span>
            <span>实占面积导入</span>
          </div>
        </div>
      </div>
      <div class="real-area-right-container">
        <div class="table" v-if="tableData.length">
          <el-table :data="tableData" style="width: 100%" :header-cell-class-name="headerCellClassName">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
              :min-width="item.width"
              :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
            ></el-table-column>
          </el-table>
          <div class="pagination">
            <pagination-tpl
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @queryChange="queryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div v-else class="nothing">
          <img class="nothing-img" src="../../../../assets/images/nothing/real-area-nothing.png">
        </div>
      </div>
    </div>

    
    <!-- 实占面积导入 -->
    <el-drawer
      class="export-real-area"
      title="实占面积导入"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <div class="el-drawer__body">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="tips">
            <img class="sign-blue" src="../../../../assets/images/sigh/sigh-blue.png">
            <span class="tips-content">导入客户实占面积，算得场租费用</span>
            <span class="tips-text">（功能介绍）</span>
          </div>
          <el-form-item label="仓库名称" prop="warehouseName">
            <el-input v-model="form.warehouseName" placeholder="请输入" disabled></el-input>
          </el-form-item>
          <el-form-item label="下载导入模板">
            <div class="download-tmp" @click="downloadTmp">
              实占面积导入模板.xlsx
              <img class="upload-bottom" src="../../../../assets/images/upload/upload-bottom.png">
            </div>
          </el-form-item>
          <el-form-item label="导入日期" prop="date">
            <el-date-picker
              v-model="form.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="实占面积导入">
            <el-input v-if="!uploadFileName" v-model="uploadFileName" placeholder="请上传文件" disabled>
              <template slot="suffix">
                <el-upload
                  v-loading.fullscreen.lock="loading"
                  element-loading-text="文件上传中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  class="upload"
                  ref="upload"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="true"
                  :before-upload="uploadRealAreaExcel"
                >
                  <img class="upload-img" src="../../../../assets/images/home/upload.png">
                </el-upload>
              </template>
            </el-input>
            <div v-else class="show-name">
              <span>{{ uploadFileName }}</span>
              <img @click="clearUploadFileName" src="../../../../assets/images/close.png">
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm('form')">确定</el-button>
      </div>
    </el-drawer>
    
    <!-- 场租重算 -->
    <el-drawer
      title="场租重算"
      width="960px"
      class="rent-recalculation"
      :wrapperClosable="false"
      :visible.sync="rentRecalculationDrawer"
      :before-close="handleCloseRentRecalculationDrawer">
      <div class="drawer-content">
        <!-- 场租重算列表 -->
        <div class="table">
          <el-table :data="rentRecalculationTablelList" style="width: 100%;">
            <el-table-column
              v-for="(item, index) in rentRecalculationTableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
              :min-width="item.width"
            >
              <template slot-scope="scope">
                <div v-if="item.prop === 'statusVal'" >
                  {{scope.row[item.prop]}}
                  <i v-if="item.prop === 'statusVal' && scope.row.status == 1" class="el-icon-loading"></i>
                </div>
                <div 
                  v-else
                  style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;"
                >
                  {{scope.row[item.prop]}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status == 0" class="btn-text" type="text" @click="carryOut(scope.row.id)"
                  >执行</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseRentRecalculationDrawer">取消</el-button>
        <el-button class="btn-blue" @click="handleCloseRentRecalculationDrawer">确认</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import warehouseMixins from "@/common/mixins/warehouse.js"
import projectMixins from "@/common/mixins/project.js"
import RealArea from '@/models/real-area.js'
import { downLoadFile, formatTimeToDate, downLoadFileByBlob } from "common/js/util";
export default {
  mixins: [warehouseMixins, projectMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      // 选择的仓库id
      warehouseRealAreaId: null,
      activeIndex: 0,
      // 导入日期
      date: this.timeDefault(),
      projectId: null,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '导入日期', prop: 'date', width: '', alignment:'left'},
        {label: '创建日期', prop: 'createDate', width: '', alignment:'left'},
        {label: '项目名称', prop: 'projectName', width: '', alignment:'left'},
        {label: '面积', prop: 'area', width: '', alignment:'right'},
        {label: '货架（个）', prop: 'goodsShelves', width: '', alignment:'right'},
        {label: '地堆（个）', prop: 'heaps', width: '', alignment:'right'}
      ],

      drawer: false,
      formData: null,
      uploadFileName: '',
      loading: false,
      form: {
        warehouseName: null,
        date: ''
      },
      rules: {
        date: [
          { required: true, message: '请选择导入日期', trigger: 'change' },
        ],
      },
      // 场租重算开关
      rentRecalculationDrawer: false,
      // 场租重算列表
      rentRecalculationTablelList: [],
      rentRecalculationTableTitleList: [
        {label: '项目名称', prop: 'projectName', width: '130'},
        {label: '重算日期', prop: 'rerunDate', width: '130'},
        {label: '重算值', prop: 'recalValue', width: '200'},
        {label: '状态', prop: 'statusVal', width: ''},
      ],
      statusObj: {
        0:'未处理',
        1:'处理中',
        2:'已处理'
      },
      selectDate: "",
      //日期选择范围在31天内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== "") {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
    }
  },

  async created() {
    await this.initWarehouseRealAreaList()
    // 默认选择第一个仓库
    this.selectWarehouse(this.warehouseRealAreaList[0], 0)
  },

  methods: {
    /**
     * @desc 实占面积列表
     */
    initRealAreaList() {
      let startDate	 = this.date?this.date[0]:''
      let endDate	 = this.date?this.date[1]:''
      let pageNo = this.currentPage
      let projectId	 = this.projectId
      let warehouseId = this.warehouseRealAreaId
      let data = {
        warehouseId,
        projectId,
        startDate,
        endDate,
        pageNo,
      }
      RealArea.getRealAreaList(data).then(res => {
        if (res.success) {
          let { totalNum, pageSize, items } = res.result
          this.total = totalNum
          this.pageSize = pageSize
          let arr = []
          items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.date = i.importTime?formatTimeToDate(i.importTime): ''
            obj.createDate = i.createTime?formatTimeToDate(i.createTime): ''
            obj.projectName = i.projectsName
            obj.area = i.useArea
            obj.goodsShelves = i.shelvesNum
            obj.heaps = i.heapNum
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /** 
     * @desc 场租重算列表
     * @params type: 1开启抽屉；2：不开启抽屉
    */
    initRentRecalculationList(type) {
      RealArea.getRentRecalculationList().then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.rerunDate = `${i.billStartDate}~${i.billEndDate}`
            obj.projectName = i.projectName
            obj.recalValue = JSON.stringify(i.recalValue)
            obj.status = i.dealStatus
            obj.statusVal = this.statusObj[i.dealStatus]
            arr.push(obj)
          })
          this.rentRecalculationTablelList = arr
          if (type === 1) this.rentRecalculationDrawer = true
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex}) {
      if (columnIndex > 2) {
        return 'right-align'
      }
    },

    /**
     * @desc 搜索
     */
    searchRealArea() {
      this.currentPage = 1;
      this.initRealAreaList()
    },

    reset() {
      this.date = this.timeDefault()
      this.projectId = null
    },

    /** 
     * @desc 默认本月1号到当天
    */
    timeDefault() {
      let date = new Date();
      const today = formatTimeToDate(date.getTime())
      const firstDate = formatTimeToDate(date.setDate(1))
      let arr = [firstDate, today]
      if (new Date().getDate() === 1)  arr = [firstDate, today]
      return arr;
    },

    /**
     * @desc 选择仓库初始化实占面积列表
     */
    selectWarehouse(row, index) {
      this.activeIndex = index
      this.form.warehouseName = row.name
      this.warehouseRealAreaId = row.id
      this.initProjectListByWarehouse(row.id)
      this.initRealAreaList()
    },

    openUploadExcel() {
      this.drawer = true
    },
    
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initRealAreaList()
    },
    
    handleCloseDrawer() {
      this.formData = null
      this.uploadFileName = ''
      this.$refs['form'].resetFields();
      this.drawer = false
    },

    downloadTmp() {
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E5%AE%9E%E5%8D%A0%E9%9D%A2%E7%A7%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF_new.xlsx'
      downLoadFile('实占面积导入模板',url)
    },

    uploadRealAreaExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadFileName = file.name
      if (file) {
        this.loading = false
      }
      return false;
    },

    /**
     * @desc 导入实占面积
     */
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = this.formData
          if (formData.get('warehouseId')) {
            formData.delete('warehouseId')
          }
          if (formData.get('importDate')) {
            formData.delete('importDate')
          }
          formData.append("warehouseId", this.warehouseRealAreaId);
          formData.append("importDate", this.form.date);
          RealArea
            .postUploadRealAreaExcel(formData)
            .then(res => {
              if (res.success) {
                this.$message.success("导入成功");
                this.initRealAreaList();
                this.handleCloseDrawer()
              } else {
                this.$confirm(res.message, "提示", {
                  showCancelButton: false,
                  confirmButtonText: "确定",
                  type: "warning"
                }).then(() => {});
              }
            })
            .catch(res => {
              console.log(res);
              this.$message.error("导入失败");
            });
         }else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    /**
     * @desc 删除上传文件
     */
    clearUploadFileName() {
      this.uploadFileName = ''
      let formData = this.formData
      if (formData.get('file')) {
        formData.delete('file')
      }
    },

    /** 
     * @desc 开启场租重算
    */
    openRentRecalculation() {
      this.initRentRecalculationList(1)
    },

    /** 
     * @desc 关闭场租重算
    */
    handleCloseRentRecalculationDrawer() {
      this.rentRecalculationDrawer = false
    },

    /** 
     * @desc 执行
    */
    carryOut(id) {
      RealArea.postCarryOut(id).then(res => {
        if (res.success) {
          this.initRentRecalculationList(2)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    downLoadExcel() {
      let startDate	 = this.date?this.date[0]:''
      let endDate	 = this.date?this.date[1]:''
      let pageNo = this.currentPage
      let projectId	 = this.projectId
      let warehouseId = this.warehouseRealAreaId
      let data = {
        startDate,
        endDate,
        warehouseId,
        projectId,
        pageNo,
      }
      RealArea.getExportRealAreaExcel(data).then((res) => {
        downLoadFileByBlob(res)
      });
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/warehouse/real-area.scss';
</style>
